import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import "./DashboardHeader.scss";
import { Dropdown } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { CustomModal } from "components/modals/ModalBox";
import { FaAngleDown, FaUserEdit, FaBars } from "react-icons/fa";
import { IoCloseSharp, IoLogOutOutline } from "react-icons/io5";
import { MdLogout } from "react-icons/md";
import { bellIcon, notificationIcon } from "assets/icons";
import { removeToken } from "config/axiosInstance";
import { logoutApi } from "services/auth";
import OrderContext from "context/orderContext/OrderContext";
import { messaging, onMessageListener, requestForToken } from "config/firebase";
import { toast } from "sonner";
import { onMessage } from "firebase/messaging";

import ringtone from '../../assets/Aduio/wiw-ring.wav'
import { useDispatch } from "react-redux";
import { fetchOrderList } from "store/orderSlice/OrderSlice";
import { markHighlight, markSeen, orderSeenId, supportSeenId, prescriptionSeenId } from "utils/seenNotifications";

// The push payload carries the reference id of the record the notification is
// about; backends name it differently (and FCM data values are always strings,
// sometimes a stringified JSON blob), so normalise then probe the common keys.
const extractRefId = (rawData) => {
  let data = rawData || {};

  // FCM often nests the real payload under data.data / data.payload as a
  // JSON string — unwrap it so we can read the id out.
  ["data", "payload", "body"].forEach((k) => {
    if (typeof data[k] === "string") {
      try {
        const parsed = JSON.parse(data[k]);
        if (parsed && typeof parsed === "object") data = { ...data, ...parsed };
      } catch {
        /* not JSON, ignore */
      }
    } else if (data[k] && typeof data[k] === "object") {
      data = { ...data, ...data[k] };
    }
  });

  return (
    data.id ||
    data._id ||
    data.referenceId ||
    data.ticketId ||
    data.queryId ||
    data.supportId ||
    data.orderId ||
    data.prescriptionId ||
    null
  );
};

// Flag the exact record's row for highlight the moment its notification arrives.
// Uses the payload's `type` (e.g. "support"/"order"/"prescription"); falls back
// to the title text.
const markNotifHighlight = (type, title, refId) => {
  if (!refId) return;
  const t = `${type || ""} ${title || ""}`.toLowerCase();
  if (t.includes("order")) {
    markHighlight(orderSeenId(refId));
  } else if (
    t.includes("support") ||
    t.includes("query") ||
    t.includes("ticket")
  ) {
    markHighlight(supportSeenId(refId));
  } else if (t.includes("prescription")) {
    markHighlight(prescriptionSeenId(refId));
  }
};

const getNotificationSeenId = (type, title, refId) => {
  if (!refId) return null;
  const t = `${type || ""} ${title || ""}`.toLowerCase();
  if (t.includes("order")) return orderSeenId(refId);
  if (t.includes("support") || t.includes("query") || t.includes("ticket")) {
    return supportSeenId(refId);
  }
  if (t.includes("prescription")) return prescriptionSeenId(refId);
  return null;
};


const DashboardHeader = ({ toggleSidebar }) => {
  const activeToastIds = useRef([]);
  const ringingToastId = useRef(null);
  const navigateRoute = useNavigate();
  const [logoutModal, setLogoutModal] = useState(false);
  const { order, SetOrder } = useContext(OrderContext)
  const dispatch = useDispatch();
  const audioRef = useRef(null);
  const ringtoneTimerRef = useRef(null);
  const isListenerAttached = useRef(false);   // ✅ ADD THIS

  // console.log('isRinging', isRinging)
  // ---------logout------------------
  const logoutHandler = async () => {
    try {
      await logoutApi();
    } catch (error) {
      // Even if the API call fails (e.g. session already expired), still
      // clear the local session so the admin isn't stuck logged in.
    } finally {
      removeToken();
      navigateRoute("/");
    }
  };


  // useEffect(() => {
  //   SetOrder([{ name: "Mohan" }])
  // }, [])
  // useEffect(() => {
  //   dispatch(fetchOrderList({ page: 1, search: '', startDate: '', orderStatus: '' }));
  // }, []);


  useEffect(() => {
    const setTokenFun = async () => {
      const deviceToken = await requestForToken();
      // console.log({ deviceToken });
      // setDeviceToken(deviceToken);

      // console.log("deviceToken:---------->", deviceToken);
    };
    setTokenFun();
  }, []);
  


  // useEffect(() => {
  //   const unsubscribe = onMessage(messaging, (payload) => {
  //     // console.log("Foreground message received:", payload);
  //     setIsRinging(true);
  //     dispatch(fetchOrderList({ page: 1, search: '', startDate: '', orderStatus: '' }));
  //     const { title, body, image } = payload?.notification || {};
  //     toast.custom((t) => (
  //       <div className="common_notification">
  //         <img src={image || notificationIcon} alt="" />
  //         <div className="content">
  //           <h4>{title}</h4>
  //           <p>{body}</p>
  //         </div>
  //         <button
  //           onClick={() => {
  //             toast.dismiss(t);
  //             setIsRinging(false); // stop ringing when user closes toast
  //           }}
  //         >
  //           <IoCloseSharp />
  //         </button>
  //       </div>
  //     ));

  //     // fetchNotificationHandler();
  //     // fetchingUserDetails();
  //   });

  //   return () => unsubscribe(); // cleanup when component unmounts
  // }, []);


  // useEffect(() => {
  //   if (isRinging) {
  //     const ring = new Audio(ringtone);
  //     ring.loop = true;

  //     ring
  //       .play()
  //       .then(() => console.log("Autoplay started"))
  //       .catch((error) => {
  //         console.log("Autoplay blocked:", error);
  //         ring.play()
  //       });

  //     const timer = setTimeout(() => {
  //       setIsRinging(false);
  //     }, 4000);

  //     return () => {
  //       clearTimeout(timer); // cleanup timer
  //       ring.pause();        // stop audio
  //     };
  //   }
  // }, [isRinging]);

  const stopRingtone = useCallback((clearRingingToast = true) => {
    if (ringtoneTimerRef.current) {
      clearTimeout(ringtoneTimerRef.current);
      ringtoneTimerRef.current = null;
    }

    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current = null;
    }

    if (clearRingingToast) {
      ringingToastId.current = null;
    }
  }, []);

  const restartRingtone = useCallback((toastId) => {
    stopRingtone(false);

    const ring = new Audio(ringtone);
    ring.loop = true;
    audioRef.current = ring;
    ringingToastId.current = toastId;
    ring.play().catch(() => {});

    ringtoneTimerRef.current = setTimeout(() => {
      if (ringingToastId.current === toastId) {
        stopRingtone();
      }
    }, 20000);
  }, [stopRingtone]);


  
  const dismissNotificationToast = useCallback((toastId, seenId) => {
    if (!toastId) return;

    toast.dismiss(toastId);
    activeToastIds.current = activeToastIds.current.filter((id) => id !== toastId);
    if (seenId) markSeen(seenId);

    if (ringingToastId.current === toastId) {
      const previousToastId = activeToastIds.current[activeToastIds.current.length - 1];
      if (previousToastId) {
        restartRingtone(previousToastId);
      } else {
        stopRingtone();
      }
    }
  }, [restartRingtone, stopRingtone]);

 const goToModuleFromNotification = useCallback((title, refId, seenId) => {
  if (seenId) markSeen(seenId);
  stopRingtone();

  const lowerTitle = title?.toLowerCase() || "";
  if (lowerTitle.includes("order")) {
    // highlight exactly this order's row until the admin opens it
    if (refId) markHighlight(orderSeenId(refId));
    navigateRoute("/order-management");
  } else if (
    lowerTitle.includes("query") ||
    lowerTitle.includes("support") ||
    lowerTitle.includes("ticket")
  ) {
    if (refId) markHighlight(supportSeenId(refId));
    navigateRoute("/customer-support");
  } else {
    if (refId) markHighlight(prescriptionSeenId(refId));
    navigateRoute("/prescription-management");
  }
}, [navigateRoute, stopRingtone]);


  // useEffect(() => {
  //   const unsubscribe = onMessage(messaging, (payload) => {
  //     const { title, body, image } = payload?.notification || {};

  //     if (audioRef.current) {
  //       try {
  //         audioRef.current.pause();
  //         audioRef.current.currentTime = 0;
  //       } catch (e) {
  //         console.log("Audio cleanup failed:", e);
  //       }
  //     }

  //     const ring = new Audio(ringtone);
  //     ring.loop = true;
  //     audioRef.current = ring;

  //     ring
  //       .play()
  //       .then(() => console.log("Ringtone playing..."))
  //       .catch((err) => console.warn("Autoplay blocked:", err));

  //     toast.custom(
  //       (t) => (
  //         <div className="common_notification" onClick={() => {
  //       toast.dismiss(t?.id);
  //       goToModuleFromNotification(title);
  //     }}
  //     style={{ cursor: "pointer" }}>
  //           <img src={image || notificationIcon} alt="" />
  //           <div className="content">
  //             <h4>{title}</h4>
  //             <p>{body}</p>
  //           </div>
  //           <button
  //             onClick={() => {
  //               toast.dismiss(t?.id);
  //               console.log("Toast closed manually");

  //               if (audioRef.current) {
  //                 audioRef.current.pause();
  //                 audioRef.current.currentTime = 0;
  //                 audioRef.current = null;
  //               }
  //             }}
  //           >
  //             <IoCloseSharp />
  //           </button>
  //         </div>
  //       ),
  //       {
  //         duration: Infinity,
  //         onDismiss: () => {
  //           console.log("Toast dismissed programmatically");

  //           if (audioRef.current) {
  //             audioRef.current.pause();
  //             audioRef.current.currentTime = 0;
  //             audioRef.current = null;
  //           }
  //         },
  //       }
  //     );

  //     dispatch(fetchOrderList({ page: 1, search: "", startDate: "", orderStatus: "" }));
  //   });

  //   return () => {
  //     unsubscribe();
  //     if (audioRef.current) {
  //       audioRef.current.pause();
  //       audioRef.current.currentTime = 0;
  //       audioRef.current = null;
  //     }
  //   };
  // }, [dispatch]);


  useEffect(() => {
    if (!messaging) return;

    // ✅ prevent duplicate listener
    if (isListenerAttached.current) return;
    isListenerAttached.current = true;

    const unsubscribe = onMessage(messaging, (payload) => {
      const { title, body, image } = payload?.notification || {};
      // id of the record (ticket / order / prescription) this notification is about
      const refId = extractRefId(payload?.data);
      const seenId = getNotificationSeenId(payload?.data?.type, title, refId);
      // print the full notification response when a new notification arrives
      console.log("🔔 NEW NOTIFICATION:", { payload, data: payload?.data, refId });
      // highlight the matching row immediately, as soon as the notification comes
      markNotifHighlight(payload?.data?.type, title, refId);
      // tell any open management list to refetch so the just-raised record shows up
      try {
        window.dispatchEvent(
          new CustomEvent("notification:new", {
            detail: { type: payload?.data?.type, title, id: refId },
          })
        );
      } catch {
        /* non-browser env */
      }

      // show toast
      const toastId = `notification-${Date.now()}-${Math.random()}`;
      activeToastIds.current = [...activeToastIds.current, toastId];
      restartRingtone(toastId);

      toast.custom(
    (currentToastId) => (
      <div
        className="common_notification"
        onClick={() => {
          dismissNotificationToast(currentToastId, seenId);
          goToModuleFromNotification(title, refId, seenId);
        }}
        style={{ cursor: "pointer" }}
      >
        <img src={image || notificationIcon} alt="" />
        <div className="content">
          <h4>{title}</h4>
          <p>{body}</p>
        </div>

        <button
          onClick={(e) => {
            e.stopPropagation();
            dismissNotificationToast(currentToastId, seenId);
          }}
        >
          <IoCloseSharp />
        </button>
      </div>
    ),
    {
      duration: Infinity,
      id: toastId,
      onDismiss: (t) => {
        activeToastIds.current = activeToastIds.current.filter((id) => id !== t.id);

        if (ringingToastId.current === t.id) {
          const previousToastId = activeToastIds.current[activeToastIds.current.length - 1];
          if (previousToastId) {
            restartRingtone(previousToastId);
          } else {
            stopRingtone();
          }
        }
      },
    }
  );

      dispatch(fetchOrderList({ page: 1, search: "", startDate: "", orderStatus: "" }));
    });

    return () => {
      if (unsubscribe) unsubscribe();
      isListenerAttached.current = false;
      stopRingtone();
      activeToastIds.current = [];
    };
  }, [dispatch, dismissNotificationToast, goToModuleFromNotification, restartRingtone, stopRingtone]);
  return (
    <>
      <div className="dashboard_header">
        <div className="container">
          <div className="header_content">
            <button className="sidebar_toggle_btn" onClick={toggleSidebar} aria-label="Toggle Navigation Menu">
              <FaBars />
            </button>
            <div className="txt_profile">
              {/* <p>Welcome Back!</p>
              <h4>
                {personalInfo?.data?.name
                  ? personalInfo?.data?.name
                  : adminInfo?.name}{" "}
                <span>
                  <img src={handIcon} alt="" />
                </span>
              </h4> */}
            </div>
            <div className="right_content">
              {/* <Dropdown className={"customDropdown"}>
                <Dropdown.Toggle id="dropdown-basic">
                  <img src={bellIcon} alt="" />
                  <span className="cstm_dots"></span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item href="#/action-1">Coming Soon</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}
              <Dropdown className={"customDropdown profile_dropdown"}>
                <Dropdown.Toggle id="dropdown-basic">
                  {/* <img
                    src={
                      personalInfo
                        ? personalInfo?.data?.profilePreview
                          ? personalInfo?.data?.profilePreview
                          : personalInfo?.data?.profile
                        : adminInfo.profile
                    }
                    alt=""
                  /> */}
                  <p>
                    {/* <b>
                      {personalInfo?.data?.name
                        ? personalInfo?.data?.name
                        : adminInfo?.data?.name}
                    </b>{" "} */}
                    <span>Admin</span>
                  </p>
                  <FaAngleDown />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {/* <Dropdown.Item as={"span"} disabled={true}>
                    <NavLink to={`/edit-profile/${1234}`}>
                      <FaUserEdit /> Edit Profile
                    </NavLink>
                  </Dropdown.Item> */}
                  <Dropdown.Item as={"span"}>
                    <NavLink to="/change-password">
                      <FaUserEdit /> Change Password
                    </NavLink>
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={"span"}s
                    onClick={() => setLogoutModal(true)}
                  >
                    <MdLogout /> Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        show={logoutModal}
        handleClose={() => setLogoutModal(false)}
        className={"logout"}
        cancelText="Cancel"
        confirmText="Logout"
      >
        <div className="logout_content">
          <span className="icon">
            <IoLogOutOutline />
          </span>
          <h5>
            Logging out will end your current session. Please make sure to save
            any unsaved work before proceeding.
          </h5>
        </div>
        <div className={`button_wrap buttonPosition`}>
          <button
            type="button"
            className="button light"
            onClick={() => setLogoutModal(false)}
          >
            No
          </button>
          <button type="button" className="button" onClick={logoutHandler}>
            Yes
          </button>
        </div>
      </CustomModal>
    </>
  );
};
export default DashboardHeader;
